// app.routes.ts (migrated from AppRoutingModule)
import { Routes } from '@angular/router';
import { AfterLoginGuard } from './tools/after-login.guard';
import { AuthGuard } from './tools/auth.guard';
import { LegacyLeavingGuard } from './tools/legacy-leaving-guard.guard';
import { CanDeactivateGuard } from './tools/can-deactivate.guard';
import { HomeComponent } from './components/home/home.component';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [AfterLoginGuard],
    loadComponent: () => import('./components/login/login.component').then(c => c.LoginComponent),
  },
  {
    path: 'verify-device',
    canActivate: [AfterLoginGuard],
    loadComponent: () => import('./components/login/verify-device.component').then(c => c.VerifyDeviceComponent),
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'bulk-quote',
    canActivate: [AuthGuard],
    loadComponent: () => import('./components/bulk-quote/bulk-quote.component').then(c => c.BulkQuoteComponent),
  },
  {
    path: 'admin-checkmonster',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () => import('./components/checkmonster/checkmonster.component').then(c => c.CheckMonsterComponent),
  },
  {
    path: 'client-risk',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () => import('./components/client-risk/client-risk.component').then(c => c.ClientRiskComponent),
  },
  {
    path: 'legacy-qpr',
    canActivate: [AuthGuard],
    canDeactivate: [LegacyLeavingGuard],
    loadComponent: () => import('./components/legacy/legacy.component').then(c => c.LegacyComponent),
  },
  {
    path: 'create-version',
    canActivate: [AuthGuard],
    canDeactivate: [LegacyLeavingGuard],
    loadComponent: () =>
      import('./components/legacy/create-version/create-version.component').then(c => c.CreateVersionComponent),
  },
  {
    path: 'version-detail',
    canActivate: [AuthGuard],
    canDeactivate: [LegacyLeavingGuard],
    loadComponent: () =>
      import('./components/legacy/version-detail/version-detail.component').then(c => c.VersionDetailComponent),
  },
  {
    path: 'standalone-head-to-head',
    canActivate: [AuthGuard],
    canDeactivate: [LegacyLeavingGuard],
    loadComponent: () =>
      import('./components/legacy/standalone-head-to-head/standalone-head-to-head.component').then(
        c => c.StandaloneHeadToHeadComponent,
      ),
  },
  {
    path: 'qm-qpr-prov-prod-mapping',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/qm-qpr-prov-prod-mapping/qm-qpr-prov-prod-mapping.component').then(
        c => c.QmQprProvProdMappingComponent,
      ),
  },
  {
    path: 'qm-qpr-prov-prod-mapping-bus',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/qm-qpr-prov-prod-mapping-bus/qm-qpr-prov-prod-mapping-bus.component').then(
        c => c.QmQprProvProdMappingBusComponent,
      ),
  },
  {
    path: 'admin-policy-doc',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/admin-policy-doc/admin-policy-doc.component').then(c => c.AdminPolicyDocComponent),
  },
  {
    path: 'admin-policy-doc/manage',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/admin-policy-doc/manage-data/manage-data.component').then(c => c.ManageDataComponent),
  },
  {
    path: 'admin-policy-doc/add',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/admin-policy-doc/add-policy-doc/add-policy-doc.component').then(
        c => c.AddPolicyDocComponent,
      ),
  },
  {
    path: 'admin-live-document',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/admin-live-document/admin-live-document.component').then(c => c.AdminLiveDocumentComponent),
  },
  {
    path: 'replacement-items',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./components/soa-ai-questions/replacement-targets/replacement-targets.component').then(
        c => c.ReplacementTargetsComponent,
      ),
  },
  {
    path: 'ai-questions',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/soa-ai-questions/ai-questions/ai-questions.component').then(c => c.AiQuestionsComponent),
  },
  {
    path: 'ai-prompt',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/soa-ai-questions/ai-prompt/ai-prompt.component').then(c => c.AiPromptComponent),
  },
  {
    path: 'user-igroup-access-control',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/user-igroup-access-control/user-igroup-access-control.component').then(
        c => c.UserIGroupAccessControlComponent,
      ),
  },

  {
    path: 'user-device-limit',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/device-limit/user-device-limit.component').then(c => c.UserDeviceLimitComponent),
  },
  {
    path: 'pa-user-device-limit',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/device-limit/pa-user-device-limit/pa-user-device-limit.component').then(
        c => c.PaUserDeviceLimitComponent,
      ),
  },
  {
    path: 'third-party-companies',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/third-party-companies/third-party-companies.component').then(
        c => c.ThirdPartyCompaniesComponent,
      ),
  },

  {
    path: 'admin-notices',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () => import('./components/admin-notice/admin-notices.component').then(c => c.AdminNoticeComponent),
  },
  {
    path: 'admin-ads',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () => import('./components/qmads/qmads-admin.component').then(c => c.QmadsAdminComponent),
  },

  {
    path: 'admin-kiwimonster-funds',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster/kiwimonster-funds-list.component').then(c => c.KiwiMonsterFundsListComponent),
  },
  {
    path: 'admin-kiwimonster-fund/:linkId',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster/kiwimonster-fund-detail/kiwimonster-fund-detail.component').then(
        c => c.KiwiMonsterFundDetailComponent,
      ),
  },
  {
    path: 'kiwimonster-research',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/research-eval-categories.component').then(
        c => c.ResearchEvalCategoriesComponent,
      ),
  },
  {
    path: 'kiwimonster-research/val',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/research-value/research-value.component').then(
        c => c.ResearchValueComponent,
      ),
  },
  {
    path: 'kiwimonster-research/schsize',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/research-scheme-size/scheme-size.component').then(
        c => c.ResearchSchemeSizeComponent,
      ),
  },
  {
    path: 'kiwimonster-research/mangesize',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/research-size-manager/research-size-manager.component').then(
        c => c.ResearchSizeManagerComponent,
      ),
  },
  {
    path: 'kiwimonster-research/advsupport',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/research-adviser-support/research-adviser-support.component').then(
        c => c.ResearchAdviserSupportComponent,
      ),
  },
  {
    path: 'kiwimonster-research/service',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/research-service/research-service.component').then(
        c => c.ResearchServiceComponent,
      ),
  },

  {
    path: 'kiwimonster-research/tools',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/research-tools/research-tools.component').then(
        c => c.ResearchToolsComponent,
      ),
  },
  {
    path: 'kiwimonster-research/tools/manage',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/research-tools/manage-tools/manage-tools.component').then(
        c => c.ManageToolsComponent,
      ),
  },
  {
    path: 'kiwimonster-research/mangetenure',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/research-management-tenure/research-management-tenure.component').then(
        c => c.ResearchManagementTenureComponent,
      ),
  },
  {
    path: 'kiwimonster-research/options',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/research-options/research-options.component').then(
        c => c.ResearchOptionsComponent,
      ),
  },

  {
    path: 'kiwimonster-research/payouts',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/research-payouts/research-payouts.component').then(
        c => c.ResearchPayoutsComponent,
      ),
  },
  {
    path: 'kiwimonster-research/growth',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/research-growth/research-growth.component').then(
        c => c.ResearchGrowthComponent,
      ),
  },
  {
    path: 'kiwimonster-research/scheme-data',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/research-scheme-data/research-scheme-data.component').then(
        c => c.ResearchSchemeDataComponent,
      ),
  },
  {
    path: 'kiwimonster-research/scheme-ownership',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/scheme-ownership/scheme-ownership.component').then(
        c => c.SchemeOwnershipComponent,
      ),
  },
  {
    path: 'kiwimonster-research/scheme-extra-setting',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/scheme-extra-setting/scheme-extra-setting.component').then(
        c => c.SchemeExtraSettingComponent,
      ),
  },
  {
    path: 'kiwimonster-research/overall-scores',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/overall-scores/overall-scores.component').then(
        c => c.OverallScoresComponent,
      ),
  },
  {
    path: 'kiwimonster-research/fund-ext-setting',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/fund-ext-setting/fund-ext-setting.component').then(
        c => c.FundExtSettingComponent,
      ),
  },
  {
    path: 'kiwimonster-research/scheme-documents',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/kiwimonster-research/scheme-documents/scheme-documents.component').then(
        c => c.SchemeDocumentsComponent,
      ),
  },
  {
    path: 'internal-group-licenses',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/internal-group/internal-group-licenses/internal-group-licenses.component').then(
        c => c.InternalGroupLicensesComponent,
      ),
  },
  {
    path: 'group-invoice-control',
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    loadComponent: () =>
      import('./components/internal-group/group-invoice-control/group-invoice-control.component').then(
        c => c.GroupInvoiceControlComponent,
      ),
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];
